import React from "react";
import { FlameIcon } from "lucide-react";
export function ScarcityBar() {
  const spotsLeft = 7;
  return <div className="mx-auto w-full max-w-md" data-id="element-215" data-mp="2yv9lqvalqbdy">
      <div className="mb-2 flex items-center justify-center gap-1.5 text-sm font-bold text-[#c0392b]" data-id="element-216" data-mp="2yyfeqlmcpxey">
        <FlameIcon className="h-4 w-4 animate-pulse" fill="#c0392b" data-id="element-217" data-mp="2l33gw5cwfqtt" />
        ¡Solo quedan {spotsLeft} cupos al precio promocional!
      </div>
      <div className="h-4 w-full overflow-hidden rounded-full bg-gray-200 shadow-inner" data-id="element-218" data-mp="2b6gvnfgnuxr9">
        <div className="flex h-full items-center justify-end rounded-full bg-gradient-to-r from-[#e74c3c] to-[#c0392b] pr-2" style={{
        width: "93%"
      }} data-id="element-219" data-mp="2g6ctsy2ofuyw">
          <span className="text-[9px] font-bold text-white" data-id="element-220" data-mp="274vehhx3fxb9">93% RESERVADO</span>
        </div>
      </div>
      <p className="mt-1.5 text-center text-xs text-gray-500" data-id="element-221" data-mp="eypky03enph">
        El cambio de moneda se realiza de forma automática según tu país.
      </p>
    </div>;
}